export const LOCALE_LOCAL_STORAGE_KEY = 'locale';

export enum ILocales {
  ru = 'RU',
  en = 'EN',
  uz = 'UZ',
}
